import clone from 'lodash/clone';
import merge from 'lodash/merge';
import isEmpty from 'lodash/isMatch';
import cloneDeep from 'lodash/cloneDeep';
import mapValues from 'lodash/mapValues';
import keyBy from 'lodash/keyBy';

import { colorsForWhiteText, mvdAddressCodes } from './constants';

// Опции для datepickerа
const datePickerOptions = {
  firstDayOfWeek: 1,
};

// Диапазон числа
const rangeNumber = (start, end) => [...Array(end - start + 1)].map((_, i) => start + i);

// фикс бага создания даты из строки в Mozilla Firefox
const dateFromString = function (str) {
  const [d, m, y] = str.split('.');
  return new Date(y, m - 1, d);
};

// Проверка объекта на пустоту
const isEmptyObject = (obj) => Object.keys(obj).length === 0;

// Проверка что строка null или empty
const isEmptyOrNullString = (str) : boolean => (str === null) || (typeof str === 'string' && !str.trim());

// Приведение в локальную дату
const toLocaleDate = (date, type = 'time') => {
  if (typeof date === 'undefined' || date === null || date == '') {
    return '';
  }
  // console.log(1, typeof(date));
  if (date instanceof Date) {
    return date.toLocaleDateString('ru-Ru');
  }
  const arr = date.split(/[- :]/);
  // @ts-ignore
  const objDate = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], `${arr[5]}`.substr(0, 2));
  if (type === 'time') {
    return `${objDate.toLocaleDateString('ru-Ru')} ${objDate.toLocaleTimeString('ru-Ru', {
      hour: '2-digit',
      minute: '2-digit',
    })}`;
  }
  if (type === 'day') {
    return objDate.toLocaleDateString('ru-Ru');
  }
  // return date.toLocaleDateString("ru-Ru")
};

// простой фильтр-словарь
const lookInDictionary = (key, dictionary, options) => {
  const o = {
    key: 'id',
    value: 'name',
    ...options,
  };
  const properDictionary = mapValues(keyBy(dictionary, o.key), o.value);
  return properDictionary.hasOwnProperty(key) ? properDictionary[key] : key;
};
const capitalize = (value) => {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
};

const excelDateToJSDate = (serial) => {
  if (typeof serial === 'undefined' || serial === null || serial == '' || serial == 0) {
    return '';
  }
  return new Date(serial * 1000);
};

const ucfirst = function ucfirst(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const getFirstLettersFromText = (text: string = '') => {
  if (text.length === 0 || text === null) {
    return '';
  }
  return text.split(' ').reduce((prevStr, str) => prevStr + str.charAt(0).toUpperCase(), '');
};

const getColourByTextLetters = (text: string): string => {
  const firstLetters = getFirstLettersFromText(text);
  const symbolsCharCode: number = firstLetters
    .split('')
    .reduce((oldVal, val) => oldVal + val.charCodeAt(0), 0);
  const colorIndex = symbolsCharCode % colorsForWhiteText.length;
  return colorsForWhiteText[colorIndex];
};

const parseResponseHeaders = (headerStr) => {
  const headers = {};
  if (!headerStr) {
    return headers;
  }
  const headerPairs = headerStr.split('; ');
  for (let i = 0, len = headerPairs.length; i < len; i += 1) {
    const headerPair = headerPairs[i];
    const index = headerPair.indexOf('=');
    if (index > 0) {
      const key = headerPair.substring(0, index);
      let val = headerPair.substring(index + 1);
      if (key == 'filename*') {
        val = val.substring(7);
      }
      if (key == 'filename') {
        val = val.substring(0, val.length);
      }
      headers[key] = decodeURI(val);
    }
  }
  return headers;
};

const saveFile = (blob, name) => {
  // @ts-ignore
  name = name || 'download';
  // Use native saveAs in IE10+
  if (typeof navigator !== 'undefined') {
    if (/MSIE [1-9]\./.test(navigator.userAgent)) {
      alert('IE is unsupported before IE10');
      return;
    }
    // @ts-ignore
    if (navigator.msSaveOrOpenBlob) {
      // https://msdn.microsoft.com/en-us/library/hh772332(v=vs.85).aspx
      // alert('will download using IE10+ msSaveOrOpenBlob');
      // @ts-ignore
      navigator.msSaveOrOpenBlob(blob, name);
      return;
    }
  }
  // Construct URL object from blob
  const win_url = window.URL || window.webkitURL || window;
  const url = win_url.createObjectURL(blob);
  // Use a.download in HTML5
  const a = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
  if ('download' in a) {
    // alert('will download using HTML5 a.download');
    // @ts-ignore
    a.href = url;
    // @ts-ignore
    a.download = name;
    // @ts-ignore
    console.log(a);
    // @ts-ignore
    a.dispatchEvent(new MouseEvent('click'));
    // Don't revoke immediately, as it may prevent DL in some browsers
    setTimeout(() => {
      win_url.revokeObjectURL(url);
    }, 500);
    return;
  }
  // Use object URL directly
  window.location.href = url;
  // Don't revoke immediately, as it may prevent DL in some browsers
  setTimeout(() => {
    win_url.revokeObjectURL(url);
  }, 500);
};

const saveFileFromResponse = (response) => {
  let filename: any = parseResponseHeaders(response.headers['content-disposition']);
  // console.log(response.headers['content-disposition']);
  if (filename['filename*']) {
    filename = filename['filename*'];
  } else {
    // @ts-ignore
    filename = JSON.parse(filename.filename);
  }
  // @ts-ignore
  const name = decodeURI(filename);
  // vue resource не трогает содержимое текстовых файлов,
  // поэтому делать из него Blob нужно самостоятельно
  if (typeof response.data === 'string') {
    response.data = new Blob(
      [response.data], // первый аргумент - массив
      { type: response.headers['content-type'] },
    );
  }

  saveFile(response.data, name);
};

const generateCrudEndpoints = (urlEndpoint: string): CRUDEndpointCollection => ({
  LIST: {
    method: 'GET',
    url: urlEndpoint,
  },
  LIST_BRIEF: {
    method: 'GET',
    url: urlEndpoint,
  },
  GET(id: number) {
    return {
      method: 'GET',
      url: `${urlEndpoint}/${id.toString()}`,
    };
  },
  STORE: {
    method: 'POST',
    url: urlEndpoint,
  },
  UPDATE(id: number) {
    return {
      method: 'PUT',
      url: `${urlEndpoint}/${id.toString()}`,
    };
  },
  DELETE(id: number) {
    return {
      method: 'DELETE',
      url: `${urlEndpoint}/${id.toString()}`,
    };
  },
});

const passwordGenerate = (length : number = 10): string => {
  const charSet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789^&/()';
  const passArray = Array.from({ length });

  return passArray.map((_, index) => charSet.charAt(Math.random() * charSet.length)).join('');
};

const generateFIO = (lastName:string = '', firstName: string = '', patronymic: string = ''): string => {
  const result: Array<string> = [];
  if (!isEmptyOrNullString(lastName)) {
    result.push(lastName);
  }
  if (!isEmptyOrNullString(firstName)) {
    result.push(firstName);
  }
  if (!isEmptyOrNullString(patronymic)) {
    result.push(patronymic);
  }
  return result.join(' ');
};

const generateShortFIO = (lastName:string = '', firstName: string = '', patronymic: string = ''): string => {
  const result: Array<string> = [];
  if (!isEmptyOrNullString(lastName)) {
    result.push(lastName);
  }
  if (!isEmptyOrNullString(firstName)) {
    result.push(`${firstName[0]}.`);
  }
  if (!isEmptyOrNullString(patronymic)) {
    result.push(`${patronymic[0]}.`);
  }
  return result.join(' ');
};

const converter: Readonly<Record<string, string>> = {
  а: 'a',
  б: 'b',
  в: 'v',
  г: 'g',
  д: 'd',
  е: 'e',
  ё: 'e',
  ж: 'zh',
  з: 'z',
  и: 'i',
  й: 'y',
  к: 'k',
  л: 'l',
  м: 'm',
  н: 'n',
  о: 'o',
  п: 'p',
  р: 'r',
  с: 's',
  т: 't',
  у: 'u',
  ф: 'f',
  х: 'h',
  ц: 'c',
  ч: 'ch',
  ш: 'sh',
  щ: 'sch',
  ь: '',
  ы: 'y',
  ъ: '',
  э: 'e',
  ю: 'yu',
  я: 'ya',
  А: 'A',
  Б: 'B',
  В: 'V',
  Г: 'G',
  Д: 'D',
  Е: 'E',
  Ё: 'E',
  Ж: 'Zh',
  З: 'Z',
  И: 'I',
  Й: 'Y',
  К: 'K',
  Л: 'L',
  М: 'M',
  Н: 'N',
  О: 'O',
  П: 'P',
  Р: 'R',
  С: 'S',
  Т: 'T',
  У: 'U',
  Ф: 'F',
  Х: 'H',
  Ц: 'C',
  Ч: 'Ch',
  Ш: 'Sh',
  Щ: 'Sch',
  Ь: '',
  Ы: 'Y',
  Ъ: '',
  Э: 'E',
  Ю: 'Yu',
  Я: 'Ya',
};

/**
 * Транслитерирование строки
 * Привет -> privet
 *
 * @param str
 */
const transliterateString = (str: string): string => {
  const transliteratedString = str
    .split('')
    .map((letter) => converter[letter] ?? letter)
    .join('');

  return transliteratedString;
};

const transliterateRusStringToSlug = (str: string): string => {
  // Вырезаем цифры и другие символы вначале строки
  const translitString = transliterateString(str).trim().replaceAll(' ', '_').toLowerCase();
  const normalizedString = translitString
    .replace(/(^[^a-z]*)([.]*)/, '')
    .replace(/[^a-z0-9_]/g, '');

  return normalizedString;
};

const generateFirstCharFIO = (lastName:string = '', firstName: string = '', patronymic: string = ''): string => {
  const result: Array<string> = [];
  if (!isEmptyOrNullString(lastName)) {
    result.push(`${lastName[0]}`);
  }
  if (!isEmptyOrNullString(firstName)) {
    result.push(`${firstName[0]}`);
  }
  if (!isEmptyOrNullString(patronymic)) {
    result.push(`${patronymic[0]}`);
  }
  return result.join('');
}

const getAddressTitleFromArrAddress = (addresses) : string => {
  let addressTitle = '';
  if (addresses !== null) {
    let filteredAddresses = addresses.filter((item) => item.type === mvdAddressCodes.REGISTRATION_ADDRESS_CODE);
    if (filteredAddresses.length === 0) {
      filteredAddresses = addresses.filter((item) => item.type === mvdAddressCodes.RESIDENTIAL_ADDRESS_CODE);
    }
    if (filteredAddresses.length > 0) {
      addressTitle = filteredAddresses[filteredAddresses.length - 1].fullAddress;
    }
  }
  return addressTitle;
};

/**
 * Вычисляем рабочий день через 5 дней не считая сегодня
 * (ПОКА РАБОТАЕТ НА КОСТЫЛЯХ)
 * просто прибавляется 8 дней к сегодняшнему
 * @returns Date
 */
const firstWorkDayAfterNext5 = (): Date => {
  const now = new Date();
  // TODO: каким-то образом надо действительно вычислять рабочие дни,
  // возможно даже задействовать при этом бек, так как там будет производственный календарь
  const enlargedGap = 5 + 1 + 2;
  const second = 1000;
  return new Date(now.getTime() + enlargedGap * 24 * 60 * 60 * second);
};

const motherRussiaNumbers = new Intl.NumberFormat('ru-RU');

const motherRussiaDateTime = new Intl.DateTimeFormat('ru-RU', {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  // second: 'numeric',
});


/**
 * Изменяем формат телефона на международный
 * т.е. из 83467360100 => +73467360100
 *
 * @param phone
 */
const fixFormatPhoneToIntl = (phone: string | undefined): string | undefined => {
  if (phone === null || typeof phone === 'undefined') {
    return phone;
  }
  const firstCharacter = phone.charAt(0);
  if (firstCharacter === '7' || firstCharacter === '8') {
    return `${'+7'}${phone.substring(1)}`;
  }
  return phone;
};

export {
  datePickerOptions,
  rangeNumber,
  isEmptyObject,
  toLocaleDate,
  lookInDictionary,
  clone,
  cloneDeep,
  merge,
  isEmpty,
  isEmptyOrNullString,
  getFirstLettersFromText,
  capitalize,
  dateFromString,
  ucfirst,
  excelDateToJSDate,
  getColourByTextLetters,
  generateCrudEndpoints,
  passwordGenerate,
  saveFileFromResponse,
  generateFIO,
  generateShortFIO,
  getAddressTitleFromArrAddress,
  motherRussiaNumbers,
  motherRussiaDateTime,
  firstWorkDayAfterNext5,
  fixFormatPhoneToIntl,
  transliterateString,
  transliterateRusStringToSlug,
  generateFirstCharFIO,
};
